module.exports = "/static/assets/5c546394bc410d9f6bbe98486e362d37.gif";